import { render, staticRenderFns } from "./AnnotatorList.vue?vue&type=template&id=da598862&"
import script from "./AnnotatorList.vue?vue&type=script&lang=js&"
export * from "./AnnotatorList.vue?vue&type=script&lang=js&"
import style0 from "./AnnotatorList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports